const actionsType = {
    GET_PRODUCTS: 'GET_PRODUCTS',
    GET_PRODUCTS_SKU: 'GET_PRODUCTS_SKU',
    GET_SEARCH_PRODUCTS: 'GET_SEARCH_PRODUCTS',
    GET_SHELF_PRODUCTS: 'GET_SHELF_PRODUCTS',
    GET_PRODUCT: 'GET_PRODUCT',

    GET_CART: 'GET_CART',
    ADD_ITEM_CART: 'ADD_ITEM_CART',
    REMOVE_ITEM_CART: 'REMOVE_ITEM_CART',
    CART_LOADING: 'CART_LOADING',
    CLEAR_CART: 'CLEAR_CART',
    UPDATE_CART: 'UPDATE_CART',
    SET_CUPON: 'SET_CUPON',
    SET_PAYMENT: 'SET_PAYMENT',
    SET_SHIPPING_DATA: 'SET_SHIPPING_DATA',
    SET_PROFILE_DATA: 'SET_PROFILE_DATA',
    GET_ORDER_INFO: 'GET_ORDER_INFO',
    SET_ORDER_INFO: 'SET_ORDER_INFO',

    SET_RECEIVER_DATA: 'SET_RECEIVER_DATA',
    GET_USER_INFO: 'get_user_info',
    GET_ACCOUNT_BANK_INFO: 'get_account_bank_info',

    GET_MESSAGES: 'get_messages_chat',
    SET_MESSAGE: 'update_messages_chat',

    MODAL: {
        VALIDATION_CODE_OPEN: 'validation_code_open',
        VALIDATION_CODE_CLOSE: 'validation_code_close',
        CRITERIA_SUBSTITUTION_OPEN: 'modal_criteria_substitution_open',
        CRITERIA_SUBSTITUTION_CLOSE: 'modal_criteria_substitution_close',
        DELIVERY_SELECTOR_OPEN: 'delivery_selector_open',
        DELIVERY_SELECTOR_CLOSE: 'delivery_selector_close',
        ADD_NOTES_OPEN: 'add_notes_open',
        ADD_NOTES_CLOSE: 'add_notes_close',
        FAILED_PAYMENT_OPEN: 'failed_payment_open',
        FAILED_PAYMENT_CLOSE: 'failed_payment_close',
        FAILED_PAYMENT_BANK_OPEN: 'failed_payment_bank_open',
        FAILED_PAYMENT_BANK_CLOSE: 'failed_payment_bank_close',
        ADD_TO_LIST_OPEN: 'add_to_list_open',
        ADD_TO_LIST_CLOSE: 'add_to_list_close',
        CONFIRMATION_OPEN: 'modal_confirmation_open',
        CONFIRMATION_CLOSE: 'modal_confirmation_close',
        PRODUCTS_CART_OPEN: 'cart_products_open',
        PRODUCTS_CART_CLOSE: 'cart_products_close',
        LOGIN_OPEN: 'login_open',
        LOGIN_CLOSE:'login_close',
        FEEDBACK_REGISTER_OPEN: 'modal_feedback_register_open',
        FEEDBACK_REGISTER_CLOSE: 'modal_feedback_register_close',
        PRODUCTS_LOST_OPEN: 'lost_products_open',
        PRODUCTS_LOST_CLOSE: 'lost_products_close',
        CREATE_NEW_LIST_OPEN: 'create_new_list_open',
        CREATE_NEW_LIST_CLOSE: 'create_new_list_close',
        PRODUCT_IN_CART_OPEN: 'modal_product_in_cart_open',
        PRODUCT_IN_CART_CLOSE: 'modal_product_in_cart_close',
        PASSWORD_OPEN: 'forgot_password_open',
        PASSWORD_CLOSE: 'forgot_password_close',
        DATE_DELIVERY_OPEN: 'modal_date_delivery_open',
        DATE_DELIVERY_CLOSE: 'modal_date_delivery_close',
        SCHOOLS_INSCRIPTION_OPEN: 'inscription_list_open',
        SCHOOLS_INSCRIPTION_CLOSE: 'inscription_list_close',
        REGISTER_OPEN: 'register_open',
        REGISTER_CLOSE: 'register_close',
        SUGGESTED_PRODUCT_OPEN: 'suggested_product_open',
        SUGGESTED_PRODUCT_CLOSE: 'suggested_product_close',
        PERSISTS_ADDRESS_OPEN: 'modal_persist_address_open',
        PERSISTS_ADDRESS_CLOSE: 'modal_persist_address_close',
        ADDRESS_OPEN: 'address_open',
        ADDRESS_CLOSE: 'address_close',
        EDIT_USER_OPEN: 'edit_user_open',
        EDIT_USER_CLOSE: 'edit_user_close',
        NEW_FEATURE_OPEN: 'new_feature_open',
        NEW_FEATURE_CLOSE: 'new_feature_close',
        ADD_CARDS_OPEN: 'add_cards_open',
        ADD_CARDS_CLOSE: 'add_cards_close',
        RECEIVER_DATA_OPEN: 'receiver_data_open',
        RECEIVER_DATA_CLOSE: 'receiver_data_close',
        UPDATE_CLIENT_OPEN: 'update_client_open',
        UPDATE_CLIENT_CLOSE: 'update_client_close',
        RESCHEDULE_ALERT_OPEN: 'reschedule_alert_open',
        RESCHEDULE_ALERT_CLOSE: 'reschedule_alert_close',
        RESCHEDULE_CONFIRM_OPEN: 'reschedule_confirm_open',
        RESCHEDULE_CONFIRM_CLOSE: 'reschedule_confirm_close',
        ORDER_CANCEL_SUCCESS_OPEN: 'order_cancel_success_open',
        ORDER_CANCEL_SUCCESS_CLOSE: 'order_cancel_success_close',
        TERMS_AND_CONDITIONS_OPEN: 'terms_and_conditions_open',
        TERMS_AND_CONDITIONS_CLOSE: 'terms_and_conditions_close',
        VALIDATION_CODE_CHECKOUT_OPEN: 'validation_code_checkout_open',
        VALIDATION_CODE_CHECKOUT_CLOSE: 'validation_code_checkout_close',
        NEWSLETTER_OPEN: 'modal_newsletter_open',
        NEWSLETTER_CLOSE: 'modal_newsletter_close',
        ADD_BANK_ACCOUNT_OPEN: 'modal_add_bank_account_open',
        ADD_BANK_ACCOUNT_CLOSE: 'modal_add_bank_account_close',
        FOOD_CERTIFICATES_OPEN: 'modal_food_certificates_open',
        FOOD_CERTIFICATES_CLOSE: 'modal_food_certificates_close',
        SHOP_TOGETHER_OPEN:  'modal_shop_together_open',
        SHOP_TOGETHER_CLOSE:  'modal_shop_together_close'
    },
    SET_SALES_CHANNEL: 'set_sales_channel',
    LOGGED_IN: 'logged_in',
    DELETE_CARD: 'delete_card',
    SELECT_CARD: 'select_card',
    CATALOG_URL_REDIRECT: 'catalog_url_redirect',
    CATALOG_CHANGE_PROPS: 'catalog_change_props',
    UPDATE_FAVORITES: 'update_favorites',
    SET_LOADING_FAVORITES: 'SET_LOADING_FAVORITES'
};

const pages = {
    home: 2662,
    school: 11140,
    localities: 22134,
    friendlyUrls: 24725
};

const translateIcons = {
    'cat-electro-y-tecnologia': 'jumbo-icon-category-electro-y-tecnologia',
    'cat-jugueteria': 'jumbo-icon-category-jugueteria',
    'cat-libreria': 'jumbo-icon-category-libreria',
    'cat-mi-bebe': 'jumbo-icon-category-mi-bebe',
    'cat-deportes': 'jumbo-icon-category-deportes'
};

const translateFlag = {
    'Si': true,
    'No': false
}

const translateRegions ={
    'REGIÓN METROPOLITANA' :'Región Metropolitana',
    'V REGIÓN':'Región de Valparaíso',
    'IV REGIÓN':'Región de Coquimbo',
    'II REGIÓN':'Región de Antofagasta',
    'I REGIÓN':'Región de Tarapacá',
    'III REGIÓN':'Región de Atacama',
    'VI REGIÓN':'Región de O\'Higgins',
    'VII REGIÓN':'Región del Maule',
    'VIII REGIÓN':'Región del Bío Bío',
    'IX REGIÓN':'Región de La Araucanía',
    'X REGIÓN':'Región de Los Lagos',
    'XIV REGIÓN':'Región de Los Ríos',
    'XV REGIÓN':'Región de Arica y Parinacota'
}

const translateMethodStatus = {
    'store_pickup': 'Retiro en Tienda',
    'drive_through':'Click al Auto',
    'express_delivery':'Despacho a Domicilio',
    'delivery': 'Despacho a Domicilio'
}

const idPromoVtex = {
    'colaborator': 'f6b12174-a59e-477e-b5e8-843e1c0b308e',
}

const foodCertificates = {
    'Apto para APLV': {
        title: 'Alergia a la proteína de leche de vaca',
        titleHtml: 'Apto para <br> <strong>APLV</strong>',
        icon: 'jumbo-icon-certificate-milk',
        description: 'Restringe derivados lácteos y de la soya, según indicaciones del MINSAL. Permite el Fosfato Tricálcico, Carbonato de Calcio y Colorante Caramelo, pues no son obtenidos de la leche.'
    },
    'Libre de Frutos Secos': {
        title: 'Alergia a los frutos secos',
        titleHtml: 'Libre de <br> <strong>Frutos Secos</strong>',
        icon: 'jumbo-icon-certificate-nuts',
        description: 'Restringe los frutos secos y sus derivados tanto de los ingredientes como de las trazas',
    },
    'Libre de Huevo': {
        title: 'Alergia al huevo',
        titleHtml: 'Libre de <br> <strong>Huevo</strong>',
        icon: 'jumbo-icon-certificate-egg',
        description: 'Restringe el alérgeno "huevo" (de gallina u otras aves) y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Libre de Lactosa': {
        title: 'Intolerancia a la lactosa',
        titleHtml: 'Libre de <br> <strong>Lactosa</strong>',
        icon: 'jumbo-icon-certificate-milk',
        description: 'Permite sólo alimentos libres de lactosa y/o con sello "sin lactosa".',
    },
    'Libre de Maní': {
        title: 'Alergia al maní',
        titleHtml: 'Libre de <br> <strong>Maní</strong>',
        icon: 'jumbo-icon-certificate-peanut',
        description: 'Restringe el alérgeno "maní" y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Mariscos': {
        title: 'Alergia a mariscos y crustáceos',
        titleHtml: 'Libre de <strong>Mariscos</strong> <br> <strong> y Crustáceos</strong>',
        icon: 'jumbo-icon-certificate-seafood',
        description: 'Restringe el alérgeno "mariscos y crustáceos" y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Libre de Nueces': {
        title: 'Alergia a las nueces',
        titleHtml: 'Libre de <br> <strong>Nueces</strong>',
        icon: 'jumbo-icon-certificate-walnuts',
        description: 'Restringe el alérgeno "nueces" de todo tipo, y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Libre de Peces': {
        title: 'Alergia al pescado',
        titleHtml: 'Libre de <br> <strong>Peces</strong>',
        icon: 'jumbo-icon-certificate-fish',
        description: 'Restringe el alérgeno "pescado" y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Libre de Soya': {
        title: 'Alergia a la soya',
        titleHtml: 'Libre de <br> <strong>Soya</strong>',
        icon: 'jumbo-icon-certificate-soy',
        description: 'Restringe el alérgeno "soya" y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Libre de Sulfitos': {
        title: 'Alergia a los sulfitos',
        titleHtml: 'Libre de <br> <strong>Sulfitos</strong>',
        icon: 'jumbo-icon-certificate-sulphites',
        description: 'Restringe el alérgeno "sulfitos" y sus derivados, tanto de los ingredientes como de las trazas',
    },
    'Vegano': {
        title: 'Apto para Dieta Vegana',
        titleHtml: '<strong>Vegano</strong>',
        icon: 'jumbo-icon-certificate-vegan',
        description: 'Se restringen todos los ingredientes, subproductos y derivados de origen animal',
    },
    'Vegetariano': {
        title: 'Apto para Dieta Vegetariana',
        titleHtml: '<strong>Vegetariano</strong>',
        icon: 'jumbo-icon-certificate-vegetarian',
        description: 'Se restringen todos los ingredientes de origen animal. Se permiten subproductos tales como el huevo, leche, miel y sus derivados',
    },
    'Orgánico': {
        title: '',
        titleHtml: '<strong>Orgánico</strong>',
        icon: 'jumbo-icon-certificate-organic',
        description: '',
    },
    'Libre de Trigo':{
        title: 'Alergia al trigo',
        titleHtml: 'Libre de <br> <strong>Trigo</strong>',
        icon: 'jumbo-icon-certificate-gluten',
        description: 'Solo serán aptos alimentos con sella "libre de gluten" o que se encuentren publicados en las listas de algún certificador reconocido',
    },
    'Libre de Azúcar añadida': {
        title: '',
        titleHtml: 'Libre de <br> <strong>Azúcar añadida</strong>',
        icon: 'jumbo-icon-certificate-added-sugar',
        description: '',
    },
    'Apto para Diabéticos': {
        title: 'Diabetes',
        titleHtml: 'Apto para <br> <strong>Diabéticos</strong>',
        icon: 'jumbo-icon-certificate-sugar',
        description: 'Se restringen todos los azúcares refinados, junto con alimentos de alto índice glicémico',
    },
    'Libre de Gluten': {
        title: 'Alergia al trigo',
        titleHtml: 'Libre de <br> <strong>Gluten</strong>',
        icon: 'jumbo-icon-certificate-gluten',
        description: 'Solo serán aptos alimentos con sello "libre de gluten" o que se encuentren publicados en las listas de algún certificador reconocido',
    },
    'Halal': {
        title: 'Apto para Practicantes del Islam',
        titleHtml: '<strong>Halal</strong>',
        icon: 'jumbo-icon-certificate-halal',
        description: 'Se incluyen alimentos que posean el sello Halal, o que cumplan con lineamientos de algún certificador Halal reconocido',
    },
    'Kosher': {
        title: 'Apto para Practicantes del Judaísmo',
        titleHtml: '<strong>Kosher</strong>',
        icon: 'jumbo-icon-certificate-koshe',
        description: 'Se incluyen alimentos que posean el sello Kosher, o que cumplan con lineamientos de algún certificador Kosher reconocido',
    },
}

const productsSimulation = [
    {
        'idSku': '391',
        'quantidade': 1,
    },
    {
        'idSku': '11433',
        'quantidade': 1,
    },
    {
        'idSku': '25482',
        'quantidade': 1,
    },
    {
        'idSku': '5867',
        'quantidade': 1,
    },
    {
        'idSku': '5891',
        'quantidade': 1,
    },
    {
        'idSku': '5853',
        'quantidade': 1,
    },
    {
        'idSku': '277',
        'quantidade': 1,
    },
    {
        'idSku': '5901',
        'quantidade': 1,
    },
    {
        'idSku': '5906',
        'quantidade': 1,
    },
    {
        'idSku': '5872',
        'quantidade': 1,
    },
    {
        'idSku': '13591',
        'quantidade': 1,
    },
    {
        'idSku': '5869',
        'quantidade': 1,
    },
    {
        'idSku': '5881',
        'quantidade': 1,
    },
    {
        'idSku': '6870',
        'quantidade': 1,
    },
    {
        'idSku': '5876',
        'quantidade': 1,
    },
    {
        'idSku': '32333',
        'quantidade': 1,
    },
    {
        'idSku': '77375',
        'quantidade': 1,
    },
    {
        'idSku': '5870',
        'quantidade': 1,
    },
    {
        'idSku': '242',
        'quantidade': 1,
    },
    {
        'idSku': '62119',
        'quantidade': 1,
    },
    {
        'idSku': '5818',
        'quantidade': 1,
    },
    {
        'idSku': '45350',
        'quantidade': 1,
    },
    {
        'idSku': '32675',
        'quantidade': 1,
    },
    {
        'idSku': '9083',
        'quantidade': 1,
    },
    {
        'idSku': '75411',
        'quantidade': 1,
    },
    {
        'idSku': '69235',
        'quantidade': 1,
    }
]

export {
    actionsType,
    pages,
    translateIcons,
    translateFlag,
    translateRegions,
    translateMethodStatus,
    idPromoVtex,
    foodCertificates,
    productsSimulation
};

